import { client } from "../client";
import type { Earmold, Variant } from "../types/earmold.types";
import { createFile } from "./file.mutations";

export const createEarmold = async (earmold: Partial<Earmold>) => {
	// 1. Upload file
	let file = null;
	if (earmold.file) {
		file = await createFile({
			file: earmold.file as File,
			fileName: undefined,
		});
	}
	// 2. Create earmold
	const response = await client.post<Earmold>(`earmolds/`, {
		...earmold,
		fileId: file ? file.id : null,
	});
	return response.data;
};

export const updateEarmold = async ({
	id,
	earmold,
}: {
	id: number | string | undefined;
	earmold: Partial<Earmold>;
}) => {
	if (id === undefined) {
		return null;
	}
	// 1. Upload file
	let file = null;
	if (earmold.file && !("length" in earmold.file)) {
		file = await createFile({
			file: earmold.file as File,
			fileName: undefined,
		});
	}
	const response = await client.patch<Earmold>(`earmolds/${id}`, {
		...earmold,
		fileId: file ? file.id : undefined,
	});
	return response.data;
};

export const createEarmoldVariants = async ({
	id,
	variant,
}: {
	id: number | string | undefined;
	variant: Partial<Variant>;
}) => {
	if (id === undefined) {
		return null;
	}
	const response = await client.post<Earmold>(
		`earmolds/${id}/variants`,
		variant,
	);
	return response.data;
};
